export default "__VITE_ASSET__jl1bY0E7__";